import AccessibilityStore, { AriaLiveLevel } from './schema/AccessibilityStore';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';

const accessibilityStore: AccessibilityStore = {
    ariaLiveLabels: new ObservableMap<string, AriaLiveLevel>({}),
};

export const getAccessibilityStore = createStore<AccessibilityStore>(
    'accessibilityStore',
    accessibilityStore
);

export default getAccessibilityStore();
